import { useEffect, useContext, useState } from 'react';
import { useQueryClient } from 'react-query';
import appConfig from 'config';
import { sessionProvider } from 'utils';
import WsContext from 'contexts/wsContext';

export default () => {
  const queryClient = useQueryClient();
  const cable = useContext(WsContext);
  const [channel, setChannel] = useState(null);

  useEffect(() => {
    if (cable.subscriptions.subscriptions.length > 0 || appConfig.isDevelopment) return;

    const jwt = sessionProvider.jwt();

    const data = {
      channel: `SubscriptionChannel`,
      jwt,
    };

    const newChannel = cable.subscriptions.create(data, {
      received: ({ message }) => {
        if (message?.message === 'Secure Message Send') {
          queryClient.invalidateQueries(['GET', '/apis/v2/messages/inbox', { per: 10 }]);
          queryClient.invalidateQueries(['GET', '/apis/v2/messages/inbox', { page: 1, per: 1 }]);
          const conversationId = message?.response?.data?.attributes?.conversation_id;

          if (conversationId) {
            queryClient.invalidateQueries(['GET', `/apis/v2/messages/${conversationId}`, {}]);
          }
        }
      },
    });

    setChannel(newChannel);

    return () => {
      if (channel && channel.unsubscribe) channel.unsubscribe();
    };
  }, []);

  return {};
};
